export const OPENING_CASH_CALCULATOR = 'OPENING_CASH_CALCULATOR';
export const CLOSING_CASH_CALCULATOR = 'CLOSING_CASH_CALCULATOR';



// WEBPACK FOOTER //
// ./src/pages/mealsummary/constants/index.js